import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useNoSidebar } from '../../../hooks/useNoSidebar';
import styles from '../../../styles/LoginRegister.module.css';
import UserLogin from '../../items/Account/UserLogin';
import MultiStepSignup from '../../items/Signup/MultiStepSignup';
import { PostAuthDestination } from '../../../utils/paymentRouting';

const LoginRegister: React.FC<{ onLogin: () => Promise<PostAuthDestination>; }> = ({ onLogin }) => {
  useNoSidebar();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState<'login' | 'signup'>('login');
  const [error, setError] = useState<string | null>(null);

  // Check for tab query parameter on mount
  useEffect(() => {
    const tab = searchParams.get('tab');
    if (tab === 'signup') {
      setActiveTab('signup');
    }
  }, [searchParams]);

  const handleLogin = async () => {
    try {
      setError(null);
      const destination = await onLogin();
      navigate(destination ?? '/Account');
    } catch (err: any) {
      console.error('Error during login:', err);
      const errorMsg = err?.message || 'Failed to complete login. Please try again.';
      setError(errorMsg);
      // Don't navigate if there's an error
    }
  };

  return (
    <div className={styles.authPage}>
      <div className={`${styles.container} ${activeTab === 'signup' ? styles.containerWide : ''}`}>
        {error && <div className={styles.errorMessage}>{error}</div>}
        <div className={styles.tabs}>
          <button
            className={activeTab === 'login' ? styles.activeTab : styles.tab}
            onClick={() => setActiveTab('login')}
          >
            Login
          </button>
          <button
            className={activeTab === 'signup' ? styles.activeTab : styles.tab}
            onClick={() => setActiveTab('signup')}
          >
            Sign Up
          </button>
        </div>
        <div className={styles.tabContent}>
          {activeTab === 'login' ? (
            <UserLogin onLogin={handleLogin} />
          ) : (
            <MultiStepSignup />
          )}
        </div>
      </div>
    </div>
  );
};

export default LoginRegister;
